/**
 * @author        woody@zumper.com (Woody Anderson)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   ListingBase biz object is the parent for listings and legacy listings
 */

import { autoclass } from '@zcode/bizos'
import Rentable from './rentable'
import * as RentableUtils from './rentable_utils'

const upliftFromListingLocation = (field) => (t) =>
  t._data[field] || (t._data.listing_location && t._data.listing_location[field])

/**
 * base class for ~~LegacyListing &~~ Listing {Floorplan extends Listing}
 */
const ListingBase = autoclass('ListingBase', class ListingBase extends Rentable {}, {
  // uplifts from listing_location
  lat: upliftFromListingLocation('lat'),
  lng: upliftFromListingLocation('lng'),
  tz: upliftFromListingLocation('tz'),
  house: upliftFromListingLocation('house'),
  street: upliftFromListingLocation('street'),
  intersection: upliftFromListingLocation('intersection'),
  unit: upliftFromListingLocation('unit'),
  formattedAddress: upliftFromListingLocation('formatted_address'),
  floor: upliftFromListingLocation('floor'),
  state: upliftFromListingLocation('state'),
  zipcode: upliftFromListingLocation('zipcode'),
  country: upliftFromListingLocation('country'),
  neighborhoodId: upliftFromListingLocation('neighborhood_id'),
  //
  similarFilters: RentableUtils.getSimilarFilters,
  city: (t) => {
    if (t.neighborhood && t.neighborhood.city) {
      return t.neighborhood.city
    }
    return upliftFromListingLocation('city')(t)
  },
  neighborhoodName: (t) => t.neighborhood && t.neighborhood.name,
  priceTextFull: (t) => {
    if (t.minPrice > 0 || t.maxPrice > 0) {
      return t.minPrice === t.maxPrice ? t.minPriceText : `${t.minPriceText}\u2014${t.maxPriceText}`
    }
    return 'Unavailable'
  },
})
export default ListingBase
